import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstanceOrder } from "../utils/request";
import { orderApis } from "../utils/apis";

export const createOrder = createAsyncThunk("createOrder", async (payload) => {
  try {
    const axiosInstance = createAxiosInstanceOrder();
    const response = await axiosInstance.post(orderApis.createOrder, payload);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
});

export const createBulkOrder = createAsyncThunk(
  "createBulkOrder",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        orderApis.bulkApprovalOrder,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getAllOrderDetail = createAsyncThunk(
  "getAllOrderDetail",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const params = new URLSearchParams();

      // Add basic params
      params.append("skip", payload?.skip);
      params.append("limit", payload?.limit);

      // Add each status separately
      if (Array.isArray(payload?.order_status)) {
        payload?.order_status.forEach((status) => {
          params.append("order_status", status);
        });
      }

      // Add each type separately
      if (Array.isArray(payload?.type)) {
        payload?.type.forEach((type) => {
          params.append("type", type);
        });
      }
      if (payload?.search) {
        params.append("search", payload?.search);
      }
      if (payload?.sort_order) {
        params.append("sort_by", payload?.sort_by);
        params.append("sort_order", payload?.sort_order);
      }
      const response = await axiosInstance.get(
        `${orderApis?.getAllOrder}?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getOrderById = createAsyncThunk(
  "getOrderById",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(
        `${orderApis.getOrderById}/${payload?.id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateOrderItemStatus = createAsyncThunk(
  "updateOrderItemStatus",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        orderApis.updateOrderItemStatus,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getOrderItemListApproved = createAsyncThunk(
  "getOrderItemListApproved",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(
        orderApis.getOrderItemListApproved,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateOrderStatus = createAsyncThunk(
  "updateOrderStatus",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        orderApis.updateOrderStatus,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

const OrderSlice = createSlice({
  name: "Quote",
  initialState: {
    orderSlice: {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.orderSlice = action.payload;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default OrderSlice.reducer;
